<template>
  <form-navigation-tabs
    :tabs="selectedTabs"
    :simple="simple"
    :active="active"
    :enable-logging="true"
    :incident="incident"
    :module="module"
    v-on:selected="emitSelected"
  ></form-navigation-tabs>
</template>
<script>
const sourceTab = {
  name: 'source',
  label: 'Source',
  disabled: false
};

const clientTab = {
  name: 'client',
  label: 'Client',
  disabled: true
};

const accidentDescriptionTab = {
  name: 'accident_description',
  label: 'Accident Description',
  disabled: true
};

const thirdPartyTab = {
  name: 'third_parties',
  label: 'Third Parties',
  disabled: true
};

const interventionClientTab = {
  name: 'client',
  label: 'Third Party',
  disabled: true
};

const witnessesTab = {
  name: 'witnesses',
  label: 'Witnesses',
  disabled: true
};

const estimateTab = {
  name: 'estimate',
  label: 'Estimate',
  disabled: true
};

const documentsTab = {
  name: 'documents',
  label: 'Documents',
  disabled: true
};

const statementsTab = {
  name: 'statements',
  label: 'Statements',
  disabled: true
};

// const jobsTab = {
//   name: 'jobs',
//   label: 'Jobs',
//   disabled: true
// };

const emailTab = {
  name: 'email',
  label: 'Email',
  disabled: true
};

export default {
  props: {
    simple: {
      type: Boolean,
      default: false
    },
    source: {
      type: Object
    },
    active: {
      type: String,
      required: true
    },
    email: {
      type: Boolean,
      default: true
    },
    incident: {
      type: String,
      required: true
    },
    module: {
      type: String,
      required: true
    },
    tabs: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  data() {
    return {
      selectedTabs: [],
      defaultTabs: [sourceTab, clientTab, statementsTab]
    };
  },

  computed: {},

  mounted() {
    if (this.source) {
      this.setTabs(this.source);
    }
  },

  methods: {
    emitSelected(tab) {
      this.$emit('selected', tab);
    },

    setTabs(source) {
      if (source && source.incident_claim_type) {
        switch (source.incident_claim_type.name) {
          case 'accident':
            this.selectedTabs = [
              sourceTab,
              clientTab,
              accidentDescriptionTab,
              thirdPartyTab,
              witnessesTab,
              estimateTab,
              statementsTab
            ];
            break;

          case 'theft':
          case 'fire':
            this.selectedTabs = [
              sourceTab,
              clientTab,
              accidentDescriptionTab,
              witnessesTab,
              estimateTab,
              statementsTab
            ];
            break;

          case 'windscreen':
            this.selectedTabs = [sourceTab, clientTab, statementsTab];
            break;

          case 'breakdown':
            this.selectedTabs = [
              sourceTab,
              clientTab,
              accidentDescriptionTab,
              statementsTab
            ];
            break;

          case 'policy-query':
            this.selectedTabs = [sourceTab, clientTab, statementsTab];
            break;

          case 'intervention':
            this.selectedTabs = [
              sourceTab,
              interventionClientTab,
              accidentDescriptionTab,
              estimateTab,
              statementsTab
            ];
            break;

          case 'cross_hire':
            this.selectedTabs = [
              sourceTab,
              clientTab,
              accidentDescriptionTab,
              estimateTab,
              statementsTab
            ];
            break;

          default:
            this.selectedTabs = this.defaultTabs;
            break;
        }
      } else {
        this.selectedTabs = this.defaultTabs;
      }

      if (this.tabs) {
        this.selectedTabs = [...this.tabs, ...this.selectedTabs];
      }

      if (this.hasPermission('documents.read')) {
        this.selectedTabs.push(documentsTab);
      }

      if (this.email) {
        // this.selectedTabs.push(emailTab);
      }

      if (source?.referrer) {
        this.selectedTabs.forEach(tab => {
          tab.disabled = false;
        });
      }
    }
  },

  watch: {
    source(source) {
      this.setTabs(source);
    }
  }
};
</script>
